import { get } from 'lodash'

import { getUserProfileRequest, formatUserResponse } from '../../utils/user'
import { getSession } from '../../utils/auth'
import { getGuestUserCart } from './cart'
import bootIntercom from '../../utils/bootIntercom'
import { logError } from '../../utils/errors'
import { setGAUserID } from '../../analytics/userAnalytics'
import {
  getSessionRequestAction,
  getSessionSuccessAction,
  getSessionFailureAction
} from './session'
import {
  getUserRequestAction,
  getUserSuccessAction,
  getUserFailureAction,
  getGuestUserAction
} from './profile'

/**
 * When SSO request failed
 */
const handleUnAuthenticatedAction = () => {
  return dispatch => {
    dispatch(getGuestUserAction())
    bootIntercom.boot()
    // get guest user cart
    return dispatch(getGuestUserCart())
  }
}

const getUSDollarsNotice = usDollarsNotice => ({
  type: 'getUSDollarsNotice',
  payload: { usDollarsNotice: usDollarsNotice }
})

export const getUserProfile = jwtToken => dispatch => {
  dispatch(getUserRequestAction())
  return getUserProfileRequest(jwtToken)
    .then(formatUserResponse)
    .then(user => {
      bootIntercom.boot(user)
      const envatoId = get(user, 'profile.envato_id')
      setGAUserID(envatoId)
      return dispatch(getUserSuccessAction(user))
    })
    .catch(err => Promise.reject(logError(err)))
    .catch(() => {
      return dispatch(getUserFailureAction())
    })
}

export const getUser = () => {
  return (dispatch, getState) => {
    dispatch(getSessionRequestAction())

    return getSession()
      .then(res => {
        dispatch(getSessionSuccessAction(res.data.token))
        dispatch(getUserProfile(res.data.token))
        dispatch(getUSDollarsNotice(res.headers['x-display-us-dollars-notice']))
      })
      .catch(err => {
        if (err.statusCode === 401) {
          dispatch(
            getUSDollarsNotice(
              err.responseHeaders['x-display-us-dollars-notice']
            )
          )
          return dispatch(handleUnAuthenticatedAction())
        } else {
          return dispatch(getSessionFailureAction())
        }
      })
  }
}



// WEBPACK FOOTER //
// ./common/actions/user/index.js